import { memo, useCallback } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzModalTitle, } from '../../components';
import { handleModal } from '../../redux/actions/modals';
import { toastConfig } from '../../redux/actions/toast';
import { deleteWatchlistAction, updateActiveWatchlist, updateOpenWatchlist } from '../../redux/actions/watchlist';
import { API_RESPONSE_STATUS } from '../../utils/global_variables';




const DeleteWatchlistConfirmationModal = ({ setDeletingWatchlistName, deletingWatchlistName }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const { openWatchlists, activeWatchList, watchlists } = useSelector(state => state.watchList);

    //Ameersha N : BT-95888 Create Watchlist Feature --Start
    const onHide = useCallback(() => {
        dispatch(handleModal([{ "WATCHLIST_DELETE_CONFIRMATION_MODAL": false }]));
    }, [dispatch]);
    //Ameersha N : BT-95888 Create Watchlist Feature --End

    //Ameersha N : BT-95888 Create Watchlist Feature --Start
    const onConfirmDeleteWatchlist = useCallback(async () => {

        if (deletingWatchlistName?.bIsDefault) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Cannot delete default watchlists' }));
        } else {

            let resp = await dispatch(deleteWatchlistAction(deletingWatchlistName));
            if (resp?.data?.status === API_RESPONSE_STATUS.SUCCESS) {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `${deletingWatchlistName?.sWatchListName} has been deleted successfully` }));
                if (openWatchlists?.length === 1) {
                    if (deletingWatchlistName?.id === activeWatchList?.id) {
                        const nIndex = watchlists.findIndex((eachWatchlist) => eachWatchlist.id === deletingWatchlistName.id);

                        if (nIndex === 0) {
                            dispatch(updateOpenWatchlist([watchlists[nIndex + 1]]));
                            dispatch(updateActiveWatchlist(watchlists[nIndex + 1]));
                        } else if (nIndex === watchlists.length - 1) {
                            dispatch(updateOpenWatchlist([watchlists[nIndex - 1]]));
                            dispatch(updateActiveWatchlist(watchlists[nIndex - 1]));
                        } else {
                            dispatch(updateOpenWatchlist([watchlists[nIndex + 1]]));
                            dispatch(updateActiveWatchlist(watchlists[nIndex + 1]));
                        }
                    } else { }
                } else { }
            } else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Something went wrong try again' }));
            }

            onHide();
            setDeletingWatchlistName({});
        }

    }, [deletingWatchlistName, setDeletingWatchlistName, activeWatchList, openWatchlists, watchlists, onHide, dispatch]);
    //Ameersha N : BT-95888 Create Watchlist Feature --Start

    //Ameersha N : BT-95888 Create Watchlist Feature --Start
    const cancelModal = () => {
        dispatch(handleModal([{ "WATCHLIST_DELETE_CONFIRMATION_MODAL": false }]));
    };
    //Ameersha N : BT-95888 Create Watchlist Feature --end


    return (
        <BzModal data-testid="watchlist-delete-confirm-dialog" show={modals['WATCHLIST_DELETE_CONFIRMATION_MODAL']} onHide={onHide} size="sm" id="TopModal" role="dialog" aria-hidden="true" centered>
            <BzModalHeader className='modaltabs-header bdr-none'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <BzModalTitle className='font-medium font-size4 color-text'>Delete watchlist</BzModalTitle>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div data-testid="watchlist-deletewatchlist-closeicon" className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size4 color-text'>Are you sure you want to delete watchlist <span className='font-medium'>'{deletingWatchlistName?.sWatchListName}'</span></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={10} className='d-flex align-items-center'>
                            <BzButton data-testid="watchlist-deletewatchlist-cancel-button" className='btn btn-md btn-block btn-outline text-uppercase me-2' onClick={cancelModal}>Cancel</BzButton>
                            <BzButton data-testid="watchlist-deletewatchlist-delete-button" className='btn btn-md btn-block btn-primary text-uppercase ms-2' onClick={onConfirmDeleteWatchlist}>Delete</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>


    );
};

export default memo(DeleteWatchlistConfirmationModal);

